export default {
	name: 'rn-get-started',
	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},
};
